<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'teams.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <grid-filters grid-data="managersTeamsGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="managersTeamsGrid" name="managersTeamsGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
   <b-modal no-enforce-focus @shown="showModal=true" @hidden="showModal=false"   ref="teamsModalDelete" id="teamsModalDelete">
    <p>Apagar a relação?</p>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm"   variant="secondary" @click="hideModal">
        Cancelar
      </b-btn>
      <b-btn size="sm" class="float-right" variant="danger" @click="doDelete">
        Apagar
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'managersTeamsGrid',
  components: {
    Grid
  },
  data() {
    return {
      itemToDelete: null,
      filters: {
        dsr: null,
        dsr_id: null
      },
      gridFilters: [{
        field:'dsr_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'Leader'
      }, {
        field:'leader_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'Manager'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dsr_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'dsr/lst/leaders',
        field: 'dsr_id'
      }, {
        api: 'dsr/lst/managers',
        field: 'leader_id'
      }],
      url: 'teams/managers',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'dsr_id',
        title: 'Leader',
        width: '220px'
      },
      {
        field: 'leader_id',
        title: 'Manager',
        width: '220px'
      },
      {
        field: 'date_start',
        title: 'Inicio',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      },
      {
        field: 'date_end',
        title: 'Fim',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      },
      {
        command: { text: 'Apagar', className:'btn btn-danger', click: this.deleteItem },
        width: 100
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'teams.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('teams.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    },
    deleteItem(e) {
      e.preventDefault();
      var grid = this.$refs.managersTeamsGrid.getGridWidget();
      var dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
      this.itemToDelete = dataItem.id
      this.$refs.teamsModalDelete.show()
    },
    doDelete(e) {
      this.axios.delete('teams/' + this.itemToDelete).then(response => {
        this.$refs.teamsModalDelete.hide()
        this.$refs.managersTeamsGrid.reload()
        this.itemToDelete = null
      })
    },
    hideModal: function() {
      this.$refs.teamsModalDelete.hide()
    }
  }
}
</script>
